import { FC } from 'react';
import TaxAdvantageAccountsPlan from 'model/TaxAdvantageAccountsPlan';
import ContributionField from 'modules/taxAdvantaged/components/ContributionField/ContributionField';
import EmployerContributionSection from 'modules/taxAdvantaged/components/EmployerContributionSection/EmployerContributionSection';
import { useAppSelector } from 'hooks/redux';
import {
  ANNUAL_MAX_CONTRIBUTION,
  END_OF_YEAR_POLICY,
} from 'constants/languageConstants';
import { getText } from 'utils/stringUtil';

import styles from './healthCareFsaPlanInfo.module.less';

type Props = {
  plan: TaxAdvantageAccountsPlan;
};

const HealthCareFsaPlanInfo: FC<Props> = (props: Props) => {
  const { plan } = props;
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div className={styles.container}>
      {plan.employerContribution && (
        <EmployerContributionSection
          className={styles.employerContributions}
          employerContribution={plan.employerContribution}
        />
      )}
      <div className={styles.subContainer}>
        {plan.maxYearlyContribution !== null &&
          plan.maxYearlyContribution !== undefined && (
            <ContributionField
              label={getText(ANNUAL_MAX_CONTRIBUTION, language)}
              value={plan.maxYearlyContribution}
            />
          )}
        {plan.endOfYearPolicy && (
          <ContributionField
            label={getText(END_OF_YEAR_POLICY, language)}
            valueText={plan.endOfYearPolicy}
            valueEndOfYearPolicyField={true}
          />
        )}
      </div>
    </div>
  );
};

export default HealthCareFsaPlanInfo;
